// dna_frontend/src/pages/XaRaSoat.js
// (Copy và thay thế toàn bộ file)

import React, { useState, useEffect } from 'react';
import api from '../services/api';
import RaSoatModal from '../components/RaSoatModal'; 
import AddThanNhanModal from '../components/AddThanNhanModal'; 
// (MỚI) Import MUI
import { Select, MenuItem, FormControl, InputLabel, Box, Alert } from '@mui/material';

const TRANG_THAI_RA_SOAT_OPTIONS = [
  { key: '', value: '-- Tất cả Trạng thái RS --' },
  { key: 'chua_ra_soat', value: 'Chưa rà soát' },
  { key: 'xac_nhan', value: 'Xác nhận đến thu mẫu' },
  { key: 'xac_nhan_bo_sung', value: 'Xác nhận tham gia thu mẫu bổ sung' },
  { key: 'khong_lien_lac', value: 'Không liên lạc được' },
  { key: 'o_xa_khong_ve', value: 'Ở xa không về' }, 
  { key: 'khong_ve_dung_hen', value: 'Không về đúng hẹn nhưng hẹn ngày khác trong tháng 11' },
  { key: 'khong_nhu_cau', value: 'Không có nhu cầu' },
  { key: 'qua_yeu', value: 'Quá yếu (không di chuyển được)' },
  { key: 'da_thu_mau_truoc', value: 'Đã thu mẫu trước 01/7/2025' }, 
  { key: 'de_nghi_xoa', value: 'Đề nghị xóa' }, 
  { key: 'du_phong', value: 'Thân nhân dự phòng' }, 
  { key: 'khac', value: 'Khác' },
];

const TRANG_THAI_THU_MAU_DB = [
  { key: 'chua_thu', value: 'Chưa thu', color: 'gray' },
  { key: 'da_thu_mau', value: 'Đã thu mẫu', color: 'green' },
  { key: 'sai_dien', value: 'Sai diện', color: 'orange' },
  { key: 'khong_co_mat', value: 'Không có mặt', color: 'red' },
  { key: 'khong_thu_mau', value: 'Không thu mẫu', color: 'red' },
];

const TRANG_THAI_THU_MAU_FILTER_OPTIONS = [
  { key: '', value: '-- Tất cả Trạng thái TM --' },
  { key: 'chua_thu', value: 'Chưa thu' },
  { key: 'da_thu_mau', value: 'Đã thu mẫu' },
  { key: 'sai_dien', value: 'Sai diện' },
  { key: 'khong_co_mat', value: 'Không có mặt' },
  { key: 'khong_thu_mau', value: 'Không thu mẫu' },
];

const NGUON_DU_LIEU_OPTIONS = [
  { key: '', value: '-- Tất cả Nguồn --' },
  { key: 'admin_upload', value: 'Admin Upload' },
  { key: 'xa_them_moi', value: 'Xã thêm mới' },
];

const LIETSI_FILTER_OPTIONS = [
  { key: '', value: '-- Trạng thái Liệt sĩ --' },
  { key: 'da_co', value: 'Đã có Liệt sĩ' },
  { key: 'chua_co', value: 'Chưa có Liệt sĩ' },
];


function XaRaSoat() {
  // (MỚI - YC 2)
  const user = JSON.parse(localStorage.getItem('user'));
  const isAdmin = user?.role === 'admin';
  
  const [danhSach, setDanhSach] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [selectedThanNhan, setSelectedThanNhan] = useState(null); 
  const [isAddModalOpen, setIsAddModalOpen] = useState(false); 
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [limit, setLimit] = useState(50); 
  
  // (MỚI - YC 2)
  const [xaList, setXaList] = useState([]);
  const [selectedXa, setSelectedXa] = useState('');
  
  const [searchParams, setSearchParams] = useState({
     ten_tn: '',
     ten_ls: '',
     trang_thai_rs: '',
     nguon: '',
     co_ls: '',
     trang_thai_tm: ''
  });

  // (SỬA - YC 2) Tải danh sách xã nếu là Admin
  useEffect(() => {
    if (isAdmin) {
      setLoading(true);
      api.get('/data/xaphuong')
        .then(res => {
          setXaList(res.data);
          setLoading(false);
          // Admin vào thì chưa tải gì, chờ chọn xã
          setError('Admin vui lòng chọn một xã để xem dữ liệu.');
          setDanhSach([]);
          setTotalPages(0);
        })
        .catch(err => {
          console.error(err);
          setError('Lỗi tải danh sách xã.');
          setLoading(false);
        });
    } else {
      // User Xã thì tải dữ liệu của xã mình
      fetchData(1, searchParams, null);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAdmin]); // Chỉ chạy 1 lần khi load

  // (SỬA - YC 2) Thêm tham số xa_id_filter
  const fetchData = async (page, filters, xa_id_filter) => {
    setLoading(true);
    setError('');
    
    const xaFilter = xa_id_filter || (isAdmin ? selectedXa : null);
    
    if (isAdmin && !xaFilter) {
         setError('Admin vui lòng chọn một xã để xem dữ liệu.');
         setLoading(false);
         setDanhSach([]);
         setTotalPages(0);
         return;
    }

    try {
      const params = new URLSearchParams(filters);
      params.append('page', page);
      params.append('limit', limit);
      
      if (isAdmin && xaFilter) {
          params.append('xa_id_filter', xaFilter);
      }
      
      const res = await api.get(`/than-nhan?${params.toString()}`); 
      setDanhSach(res.data.data); 
      setTotalPages(res.data.totalPages);
      setCurrentPage(res.data.currentPage);
    } catch (err) { 
      console.error(err);
      setError('Không thể tải danh sách.');
      setDanhSach([]);
      setTotalPages(0);
    } finally {
      setLoading(false);
    }
  };
  
  const handleSearchChange = (e) => {
    setSearchParams({ ...searchParams, [e.target.name]: e.target.value });
  };
  
  // (SỬA - YC 2)
  const handleXaChange = (e) => {
      const newXaId = e.target.value;
      setSelectedXa(newXaId);
      // Tự động tải dữ liệu xã mới khi Admin chọn
      if (newXaId) {
          setCurrentPage(1);
          fetchData(1, searchParams, newXaId);
      } else {
          setDanhSach([]);
          setTotalPages(0);
          setError('Admin vui lòng chọn một xã để xem dữ liệu.');
      }
  };
  
  const handleSearchSubmit = (e) => {
      e.preventDefault();
      setCurrentPage(1); 
      fetchData(1, searchParams, null); // Dùng selectedXa trong state
  };
  
  const handleResetSearch = () => {
      const emptyParams = { ten_tn: '', ten_ls: '', trang_thai_rs: '', nguon: '', co_ls: '', trang_thai_tm: '' };
      setSearchParams(emptyParams);
      setCurrentPage(1);
      fetchData(1, emptyParams, null);
  };
  
  const handlePageChange = (newPage) => {
      if (newPage >= 1 && newPage <= totalPages) {
          fetchData(newPage, searchParams, null);
      }
  };

  const handleModalSave = () => {
    setSelectedThanNhan(null);
    fetchData(currentPage, searchParams, null); 
  };
  
  const handleAddModalSave = (newThanNhan) => {
    setIsAddModalOpen(false);
    // (SỬA - YC 2) Admin không reset filter, Xã thì reset
    if (!isAdmin) {
        handleResetSearch(); 
    }
  };

  if (loading && xaList.length === 0) return <p>Đang tải danh sách...</p>;
  

  const getStatusColor = (status) => {
    switch(status) {
      case 'xac_nhan': return 'green';
      case 'xac_nhan_bo_sung': return 'blue';
      case 'chua_ra_soat': return 'gray';
      case 'qua_yeu': case 'khong_lien_lac': case 'o_xa_khong_ve': case 'khong_ve_dung_hen': case 'khong_nhu_cau': case 'khac': case 'de_nghi_xoa': case 'du_phong': return 'red';
      case 'da_thu_mau_truoc': return 'blue';
      default: return 'black';
    }
  };

  return (
    <div style={{ padding: '20px' }}>
      <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
        <h2>Rà soát Thân nhân {isAdmin ? '(Admin View)' : ''}</h2>
        {/* (SỬA - YC 2) Chỉ Xã mới được thêm mới */}
        {!isAdmin && (
            <button 
                onClick={() => setIsAddModalOpen(true)}
                style={{ background: '#28a745', color: 'white', padding: '10px 15px', border: 'none', borderRadius: '5px', cursor: 'pointer' }}
            >
                + Thêm mới Thân nhân
            </button>
        )}
      </div>
      
      {!isAdmin && (
          <div style={{ background: '#e6f7ff', border: '1px solid #b3e0ff', padding: '10px', borderRadius: '5px', margin: '15px 0' }}>
            <p style={{ margin: 0, fontWeight: 500 }}>
              <strong>Hướng dẫn Thêm mới:</strong> Để thêm mới thân nhân, ấn nút "Thêm mới thân nhân", điền thông tin cá nhân của thân nhân và ấn "Lưu". 
              <br/>
              Lúc này thân nhân sẽ ở trạng thái "Chưa rà soát", tiếp tục thực hiện "Rà soát / Sửa" để hoàn thiện quy trình.
            </p>
          </div>
      )}
      
      {/* (SỬA - YC 2) Thêm ô chọn Xã cho Admin */}
      <form onSubmit={handleSearchSubmit} style={{ background: '#f4f4f4', padding: '15px', borderRadius: '8px', margin: '20px 0' }}>
         {isAdmin && (
            <FormControl fullWidth sx={{ mb: 2, background: 'white' }}>
              <InputLabel id="xa-select-label">Chọn Xã để xem/sửa</InputLabel>
              <Select
                labelId="xa-select-label"
                value={selectedXa}
                label="Chọn Xã để xem/sửa"
                onChange={handleXaChange}
              >
                <MenuItem value="">
                  <em>-- Vui lòng chọn xã --</em>
                </MenuItem>
                {xaList.map((xa) => (
                  <MenuItem key={xa.id} value={xa.id}>{xa.ten_xa}</MenuItem>
                ))}
              </Select>
            </FormControl>
         )}

        <h4>Tìm kiếm {isAdmin ? `trong xã ${xaList.find(x => x.id === selectedXa)?.ten_xa || '...'}` : 'trong xã'}</h4>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '15px' }}>
          <input type="text" name="ten_tn" value={searchParams.ten_tn} onChange={handleSearchChange} placeholder="Tên thân nhân..." />
          <input type="text" name="ten_ls" value={searchParams.ten_ls} onChange={handleSearchChange} placeholder="Tên liệt sĩ..." />
          <select name="trang_thai_rs" value={searchParams.trang_thai_rs} onChange={handleSearchChange}>
            {TRANG_THAI_RA_SOAT_OPTIONS.map(opt => <option key={opt.key} value={opt.key}>{opt.value}</option>)}
          </select>
          <select name="trang_thai_tm" value={searchParams.trang_thai_tm} onChange={handleSearchChange}>
             {TRANG_THAI_THU_MAU_FILTER_OPTIONS.map(opt => <option key={opt.key} value={opt.key}>{opt.value}</option>)}
          </select>
          <select name="nguon" value={searchParams.nguon} onChange={handleSearchChange}>
             {NGUON_DU_LIEU_OPTIONS.map(opt => <option key={opt.key} value={opt.key}>{opt.value}</option>)}
          </select>
          <select name="co_ls" value={searchParams.co_ls} onChange={handleSearchChange}>
             {LIETSI_FILTER_OPTIONS.map(opt => <option key={opt.key} value={opt.key}>{opt.value}</option>)}
          </select>
        </div>
        <div style={{marginTop: '15px'}}>
           <button type="submit" disabled={loading} style={{ background: '#007bff', color: 'white', padding: '8px 12px' }}>
            {loading ? 'Đang tìm...' : 'Tìm kiếm'}
          </button>
           <button type="button" onClick={handleResetSearch} disabled={loading} style={{ background: 'gray', color: 'white', padding: '8px 12px', marginLeft: '10px' }}>
            Xóa lọc
          </button>
        </div>
      </form>
      
      {error && <Alert severity="error">{error}</Alert>}
      
      {totalPages > 0 && (
          <div style={{ margin: '20px 0', display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '10px' }}>
              <button onClick={() => handlePageChange(1)} disabled={currentPage === 1}>Trang đầu</button>
              <button onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1}>Trang trước</button>
              <span>Trang <strong>{currentPage}</strong> / {totalPages}</span>
              <button onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages}>Trang sau</button>
              <button onClick={() => handlePageChange(totalPages)} disabled={currentPage === totalPages}>Trang cuối</button>
          </div>
      )}

      <table style={{ width: '100%', borderCollapse: 'collapse' }}>
        <thead>
          <tr style={{ background: '#f0f0f0' }}>
            <th style={{ padding: '8px', border: '1px solid #ccc' }}>STT (Trang)</th>
            <th style={{ padding: '8px', border: '1px solid #ccc' }}>Họ tên</th>
            <th style={{ padding: '8px', border: '1px solid #ccc' }}>Năm sinh</th>
            <th style={{ padding: '8px', border: '1px solid #ccc' }}>CCCD (3 số cuối)</th>
            <th style={{ padding: '8px', border: '1px solid #ccc' }}>Địa chỉ</th>
            <th style={{ padding: '8px', border: '1px solid #ccc' }}>Liệt sĩ</th>
            <th style={{ padding: '8px', border: '1px solid #ccc' }}>TT Rà soát (Xã)</th>
            <th style={{ padding: '8px', border: '1px solid #ccc' }}>TT Thu mẫu (Tỉnh)</th>
            <th style={{ padding: '8px', border: '1px solid #ccc' }}>Nguồn</th>
            <th style={{ padding: '8px', border: '1px solid #ccc' }}>Sửa</th>
            <th style={{ padding: '8px', border: '1px solid #ccc' }}>DC01</th>
            <th style={{ padding: '8px', border: '1px solid #ccc' }}>Hành động</th>
          </tr>
        </thead>
        <tbody>
          {loading && <tr><td colSpan="12" style={{textAlign: 'center', padding: '20px'}}>Đang tải dữ liệu...</td></tr>}
          {!loading && danhSach.length === 0 && !isAdmin && (
            <tr><td colSpan="12" style={{textAlign: 'center', padding: '20px'}}>Không tìm thấy dữ liệu (hoặc chưa có dữ liệu)</td></tr>
          )}
          {!loading && danhSach.length === 0 && isAdmin && !selectedXa && (
              <tr><td colSpan="12" style={{textAlign: 'center', padding: '20px'}}>Vui lòng chọn xã để xem dữ liệu</td></tr>
          )}
          {!loading && danhSach.length === 0 && isAdmin && selectedXa && (
              <tr><td colSpan="12" style={{textAlign: 'center', padding: '20px'}}>Không tìm thấy dữ liệu cho xã này</td></tr>
          )}
          
          {!loading && danhSach.length > 0 && (
            danhSach.map((tn, index) => (
              <tr key={tn.id}>
                <td style={{ padding: '8px', border: '1px solid #ccc' }}>{limit * (currentPage - 1) + index + 1}</td>
                <td style={{ padding: '8px', border: '1px solid #ccc' }}>{tn.ho_ten}</td>
                <td style={{ padding: '8px', border: '1px solid #ccc', color: !tn.nam_sinh ? 'red' : 'inherit' }}>
                  {tn.nam_sinh || 'N/A'}
                </td>
                <td style={{ padding: '8px', border: '1px solid #ccc' }}>{tn.cccd}</td>
                <td style={{ padding: '8px', border: '1px solid #ccc' }}>{tn.dia_chi}</td>
                <td style={{ padding: '8px', border: '1px solid #ccc', color: !tn.DanhSach_LietSi ? 'red' : 'inherit' }}>
                   {tn.DanhSach_LietSi || 'Chưa có'}
                </td>
                <td style={{ padding: '8px', border: '1px solid #ccc', color: getStatusColor(tn.trang_thai_ra_soat), fontWeight: 'bold' }}>
                  {TRANG_THAI_RA_SOAT_OPTIONS.find(o => o.key === tn.trang_thai_ra_soat)?.value || tn.trang_thai_ra_soat}
                </td>
                <td style={{ 
                    padding: '8px', 
                    border: '1px solid #ccc',
                    color: TRANG_THAI_THU_MAU_DB.find(o=>o.key === tn.trang_thai_thu_mau)?.color, 
                    fontWeight: 'bold' 
                }}>
                   {TRANG_THAI_THU_MAU_DB.find(o => o.key === tn.trang_thai_thu_mau)?.value || tn.trang_thai_thu_mau}
                </td>
                <td style={{ padding: '8px', border: '1px solid #ccc' }}>
                  {tn.nguon_du_lieu === 'xa_them_moi' ? 'Xã thêm' : (tn.nguon_du_lieu === 'tinh_them_moi' ? 'Tỉnh thêm' : 'Admin')}
                </td>
                <td style={{ padding: '8px', border: '1px solid #ccc', color: tn.trang_thai_chinh_sua === 'da_sua' ? 'blue' : 'black' }}>
                  {tn.trang_thai_chinh_sua === 'da_sua' ? 'Đã sửa' : 'Gốc'}
                </td>
                <td style={{ padding: '8px', border: '1px solid #ccc', textAlign: 'center' }}>
                  {tn.nguon_du_lieu === 'xa_them_moi' && (
                    <span>{tn.da_cap_nhat_dc01 ? '✔️' : '❌'}</span>
                  )}
                </td>
                <td style={{ padding: '8px', border: '1px solid #ccc', textAlign: 'center' }}>
                  <button onClick={() => setSelectedThanNhan(tn)}>
                    Rà soát / Sửa
                  </button>
                </td>
              </tr>
            ))
          )}
        </tbody>
      </table>
      
       {totalPages > 0 && (
          <div style={{ margin: '20px 0', display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '10px' }}>
              <button onClick={() => handlePageChange(1)} disabled={currentPage === 1}>Trang đầu</button>
              <button onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1}>Trang trước</button>
              <span>Trang <strong>{currentPage}</strong> / {totalPages}</span>
              <button onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages}>Trang sau</button>
              <button onClick={() => handlePageChange(totalPages)} disabled={currentPage === totalPages}>Trang cuối</button>
          </div>
      )}

      {selectedThanNhan && (
        <RaSoatModal 
          thanNhan={selectedThanNhan}
          onClose={() => setSelectedThanNhan(null)}
          onSave={handleModalSave}
          // (MỚI - YC 2)
          isAdminView={isAdmin} 
        />
      )}
      
      {isAddModalOpen && (
        <AddThanNhanModal 
          onClose={() => setIsAddModalOpen(false)}
          onSave={handleAddModalSave}
        />
      )}

    </div>
  );
}

export default XaRaSoat;